import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import * as api from '../../apiCalls'
import {createActionObject} from '../../../../redux/utils'
import {LOAD_DATA_FAILURE} from '../../actionTypes'
import {getPurchasePeriod, getStartDate, getUsersCount, isSelectUnlimitedUsers} from './selectors'
import {UNLIMITED_USERS_COUNT} from '../../constants'
import {getUsersLowerLimit} from '../../selectors'

export const setEndDate = createAction(ActionTypes.END_DATE_SET)
export const setPurchaseInfo = createAction(ActionTypes.PURCHASE_INFO_SET)

export const setUsersCountAction = createAction(ActionTypes.USERS_COUNT_SET)
export const setUnlimitedAction = createAction(ActionTypes.UNLIMITED_SET)
export const setPeriod = createAction(ActionTypes.PURCHASE_PERIOD_SET)

export const setStartDate = (date) => dispatch => {
    dispatch(createActionObject(ActionTypes.START_DATE_SET, date))
    dispatch(loadPurchaseData())
}

export const setUnlimited = (unlimited) => dispatch => {
    dispatch(setUnlimitedAction(unlimited))
    dispatch(loadPurchaseData())
}

export const setUsersCount = (usersCount) => dispatch => {
    dispatch(setUsersCountAction(usersCount))
    dispatch(loadPurchaseData(usersCount))
}

export const setPurchasePeriod = (period) => dispatch => {
    dispatch(setPeriod(period))
    dispatch(loadPurchaseData())
}

export const setUsersCountAndUnlimitedFlag = (unlimited, usersCount) => dispatch => {
    dispatch(setUsersCountAction(usersCount))
    dispatch(setUnlimitedAction(unlimited))
    dispatch(loadPurchaseData(usersCount))
}

export const loadPurchaseData = (userCount) => (dispatch, getState) => {
    // try get count from state if we haven't arg. and do save get count if in state count = 0
    // if send 0 userCount to BO we get exception
    const state = getState()
    let userCountToRequest = userCount || getUsersCount(state) || getUsersLowerLimit(state)

    if (isSelectUnlimitedUsers(state)) {
        userCountToRequest = UNLIMITED_USERS_COUNT
    }

    const monthCountToRequest = getPurchasePeriod(state)

    api.getPurchaseCardsDataThrottled(userCountToRequest, monthCountToRequest, getStartDate(state))
       .then(data => {
           dispatch(setPurchaseInfo(data))
       })
       .catch((error) => {
           dispatch(createActionObject(LOAD_DATA_FAILURE))
       })
}




// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/actions.js